import React from 'react';
interface CheckboxFieldProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}
export function CheckboxField({
  label,
  checked,
  onChange,
  disabled = false
}: CheckboxFieldProps) {
  return <label className="flex items-center gap-2 cursor-pointer" data-id="element-96">
      <input type="checkbox" checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-600 disabled:opacity-50" data-id="element-97" />
      <span className="text-sm text-gray-700" data-id="element-98">{label}</span>
    </label>;
}